import { format, isSameYear } from 'date-fns'

type SlotDay = {
  key: string
  label: string
  slots: Date[]
}

const UTC_TIME_FORMAT = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
})

export const getLocalTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

export const formatMigrationDate = (value: string | Date) => {
  const date = new Date(value)
  const dayPattern = isSameYear(date, new Date())
    ? 'EEEE, MMMM d'
    : 'EEEE, MMMM d, yyyy'

  return format(date, `${dayPattern} 'at' HH:mm`)
}

export const formatShortMigrationDate = (value: string | Date) =>
  format(new Date(value), 'MMM d')

export const formatLocalTime = (value: string | Date) =>
  format(new Date(value), 'HH:mm')

export const formatUtcTime = (value: string | Date) =>
  `${UTC_TIME_FORMAT.format(new Date(value))} UTC`

export const groupSlotsByLocalDay = (slots: string[]): SlotDay[] =>
  slots
    .map((slot) => new Date(slot))
    .sort((a, b) => a.getTime() - b.getTime())
    .reduce<SlotDay[]>((days, slot) => {
      const key = format(slot, 'yyyy-MM-dd')
      const lastDay = days.at(-1)

      if (lastDay?.key === key) {
        return [
          ...days.slice(0, -1),
          { ...lastDay, slots: [...lastDay.slots, slot] },
        ]
      }

      return [
        ...days,
        { key, label: format(slot, 'EEE, MMM d'), slots: [slot] },
      ]
    }, [])
